import { useTranslation } from "react-i18next";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Skeleton, Box } from "@mui/material";

type TableLoadingProps = {
  type: "transactions" | "invoices";
};

const TableLoading = ({ type }: TableLoadingProps) => {
  const { t } = useTranslation("plans", { keyPrefix: "page.plansOverviewPage" });

  return (
    <TableContainer>
      <Table aria-label={`${type} table`}>
        <TableHead>
          <TableRow>
            <TableCell sx={styles.headCell}>{t("paymentReason")}</TableCell>
            <TableCell sx={styles.headCell}>{t("type")}</TableCell>
            <TableCell sx={styles.headCell}>{t("amount")}</TableCell>
            <TableCell sx={styles.headCell}>{t("cardNumber")}</TableCell>
            <TableCell sx={styles.headCell}>{t("date")}</TableCell>
            <TableCell sx={styles.headCell}>{t("status")}</TableCell>
            <TableCell sx={styles.headCell}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {[...Array(10)].map((_, index) => (
            <TableRow key={index} sx={styles.tableRow}>
              <TableCell sx={styles.bodyCell}>
                <Skeleton variant="text" width={100} />
              </TableCell>
              <TableCell sx={styles.bodyCell}>
                <Skeleton variant="text" width={80} />
              </TableCell>
              <TableCell sx={styles.bodyCell}>
                <Skeleton variant="text" width={80} />
              </TableCell>
              <TableCell sx={styles.bodyCell}>
                <Skeleton variant="text" width={120} />
              </TableCell>
              <TableCell sx={styles.bodyCell}>
                <Box sx={styles.dateTimeContainer}>
                  <Skeleton variant="text" width={80} />
                  <Skeleton variant="text" width={60} />
                </Box>
              </TableCell>
              <TableCell sx={styles.bodyCell}>
                <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: "16px" }} />
              </TableCell>
              <TableCell sx={styles.bodyCell}>
                <Skeleton variant="circular" width={32} height={32} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableLoading;

const styles = {
  tableRow: {
    "&:last-child": {
      "& .MuiTableCell-root": {
        borderBottom: "none !important",
      },
    },
  },
  headCell: {
    fontFamily: "Montserrat",
    color: "var(--Gray-600, #475467)",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "18px",
    borderBottom: "1px solid var(--Gray-200, #EAECF0)",
    background: "var(--Gray-50, #F9FAFB)",
    whiteSpace: "nowrap",
    padding: "12px 16px",
  },
  bodyCell: {
    color: "var(--Gray-600, #475467)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
    borderBottom: "1px solid var(--Gray-200, #EAECF0)",
    padding: "24px 16px",
    whiteSpace: "nowrap",
  },
  dateTimeContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
};
